import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import VisibilityIcon from '@material-ui/icons/Visibility';
import HistoryIcon from '@material-ui/icons/History';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import Page from 'src/components/Page';
import AlertScreen from 'src/components/Alert';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2)
  },
  spacer: { flexGrow: 1 },
  filterCtrl: { minWidth: 220 },
  passive: { opacity: 0.55 },
  kampanyaRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  tipChip: { minWidth: 64, marginTop: 6 },
  preview: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    padding: theme.spacing(2),
    minHeight: 120,
    backgroundColor: theme.palette.background.paper
  }
}));

const TIP_AD = { 1: 'Başlık', 2: 'İçerik', 3: 'Madde' };
const tipAdi = (t) => TIP_AD[t] || 'İçerik';

const toDateInput = (val) => (val ? String(val).slice(0, 10) : '');

// Tabloda gösterim için: gün.ay.yıl (15.01.2025)
const formatTr = (val) => {
  if (!val) return '';
  const s = String(val).slice(0, 10); // yyyy-MM-dd
  const p = s.split('-');
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};

// gün.ay.yıl SS:dd
const formatTrDateTime = (val) => {
  if (!val) return '';
  const s = String(val);
  const d = s.slice(0, 10).split('-');
  const t = s.length >= 16 ? s.slice(11, 16) : '';
  return d.length === 3 ? `${d[2]}.${d[1]}.${d[0]}${t ? ' ' + t : ''}` : s;
};

const fmtMoney = (v) =>
  v === null || v === undefined ? '-' : `${Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺`;
const fmtAktif = (v) => (v === 1 ? 'Aktif' : v === 0 ? 'Pasif' : '-');

const emptyDetay = {
  Id: 0,
  UrunAnaGrup: null, // option {Kod, Aciklama}
  PaketId: '',
  BakimEkGarantiAdeti: '',
  Fiyat: '',
  FiyatBaslangic: '',
  FiyatBitis: '',
  Aktif: true
};

const emptyPaket = { Id: 0, PaketId: 0, Aciklama: '', Aktif: true };

function PaketYonetimi() {
  const classes = useStyles();

  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const [urunGruplar, setUrunGruplar] = useState([]);
  const [paketler, setPaketler] = useState([]);
  const [detaylar, setDetaylar] = useState([]);

  const [showPassive, setShowPassive] = useState(false);

  // Fiyat filtreleri
  const [filterPaketId, setFilterPaketId] = useState('');
  const [filterUrunGrup, setFilterUrunGrup] = useState(null);

  // Dialoglar
  const [detayDialogOpen, setDetayDialogOpen] = useState(false);
  const [detayForm, setDetayForm] = useState(emptyDetay);
  const [paketDialogOpen, setPaketDialogOpen] = useState(false);
  const [paketForm, setPaketForm] = useState(emptyPaket);

  // Kampanya koşulları (dinamik metin) - bellekte kur, sonda kaydet
  const [kampanyaPaketId, setKampanyaPaketId] = useState('');
  const [kampanyaItems, setKampanyaItems] = useState([]); // [{MarkdownTipId, Metin}]
  const [kosulView, setKosulView] = useState({ open: false, paketAdi: '', items: [] });
  const [logView, setLogView] = useState({ open: false, baslik: '', items: [] });

  // Snackbar
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackType, setSnackType] = useState('success');
  const [snackMessage, setSnackMessage] = useState('');

  // Onay
  const [confirmState, setConfirmState] = useState({ open: false, title: '', message: '', onConfirm: null });
  const askConfirm = (title, message, onConfirm) => setConfirmState({ open: true, title, message, onConfirm });
  const closeConfirm = () => setConfirmState((s) => ({ ...s, open: false }));

  const notify = (type, message) => {
    setSnackType(type);
    setSnackMessage(message);
    setSnackOpen(true);
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = () => {
    setLoading(true);
    Promise.all([
      axios.get('/GetUrunAnaGruplar'),
      axios.get('/GetEkGarantiPaketler'),
      axios.get('/GetEkGarantiPaketDetaylar')
    ])
      .then(([ugRes, pRes, dRes]) => {
        setUrunGruplar(Array.isArray(ugRes.data) ? ugRes.data : []);
        setPaketler(Array.isArray(pRes.data) ? pRes.data : []);
        setDetaylar(Array.isArray(dRes.data) ? dRes.data : []);
      })
      .catch(() => notify('error', 'Veriler yüklenirken bir hata oluştu.'))
      .finally(() => setLoading(false));
  };

  const paketAdi = (paketId) => {
    const p = paketler.find((x) => x.PaketId === paketId);
    return p ? p.Aciklama : paketId;
  };

  // ---- Fiyat (detay) ----
  const openAddDetay = () => {
    setDetayForm({
      ...emptyDetay,
      PaketId: filterPaketId || '',
      UrunAnaGrup: filterUrunGrup || null
    });
    setDetayDialogOpen(true);
  };

  const openEditDetay = (row) => {
    setDetayForm({
      Id: row.Id,
      UrunAnaGrup: urunGruplar.find((u) => u.Kod === row.UrunAnaGrupKodu) || { Kod: row.UrunAnaGrupKodu, Aciklama: row.UrunAnaGrupAdi },
      PaketId: row.PaketId,
      BakimEkGarantiAdeti: row.BakimEkGarantiAdeti,
      Fiyat: row.Fiyat,
      FiyatBaslangic: toDateInput(row.FiyatBaslangic),
      FiyatBitis: toDateInput(row.FiyatBitis),
      Aktif: row.Aktif
    });
    setDetayDialogOpen(true);
  };

  const setDetayField = (field, value) => setDetayForm((p) => ({ ...p, [field]: value }));

  const handleSaveDetay = () => {
    if (!detayForm.PaketId) return notify('error', 'Paket seçilmelidir.');
    if (!detayForm.UrunAnaGrup) return notify('error', 'Ürün ana grubu seçilmelidir.');
    if (detayForm.BakimEkGarantiAdeti === '' || Number(detayForm.BakimEkGarantiAdeti) < 0)
      return notify('error', 'Bakım ek garanti adeti girilmelidir.');
    if (detayForm.Fiyat === '' || Number(detayForm.Fiyat) < 0) return notify('error', 'Geçerli bir fiyat girilmelidir.');
    if (!detayForm.FiyatBaslangic || !detayForm.FiyatBitis) return notify('error', 'Geçerlilik tarihleri zorunludur.');
    if (detayForm.FiyatBaslangic > detayForm.FiyatBitis)
      return notify('error', 'Başlangıç tarihi bitiş tarihinden sonra olamaz.');

    const payload = {
      Id: detayForm.Id,
      UrunAnaGrupKodu: detayForm.UrunAnaGrup.Kod,
      PaketId: Number(detayForm.PaketId),
      BakimEkGarantiAdeti: Number(detayForm.BakimEkGarantiAdeti),
      Fiyat: Number(detayForm.Fiyat),
      FiyatBaslangic: detayForm.FiyatBaslangic,
      FiyatBitis: detayForm.FiyatBitis,
      Aktif: detayForm.Aktif
    };

    setLoading(true);
    axios
      .post('/SetEkGarantiPaketDetay', payload)
      .then((res) => {
        if (res.data && res.data.ErrorCode === '0') {
          notify('success', res.data.ErrorDescription || 'Kaydedildi.');
          setDetayDialogOpen(false);
          fetchAll();
        } else {
          notify('error', (res.data && res.data.ErrorDescription) || 'İşlem başarısız.');
        }
      })
      .catch(() => notify('error', 'Kayıt sırasında hata oluştu.'))
      .finally(() => setLoading(false));
  };

  // Bir fiyat satırının değişiklik geçmişi
  const openLogView = (row) => {
    setLoading(true);
    axios
      .get(`/GetEkGarantiFiyatLog/${row.Id}`)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        const baslik = `${row.UrunAnaGrupAdi || row.UrunAnaGrupKodu} • ${row.PaketAdi || paketAdi(row.PaketId)}`;
        setLogView({ open: true, baslik, items: list });
      })
      .catch(() => notify('error', 'Geçmiş yüklenemedi.'))
      .finally(() => setLoading(false));
  };

  // ---- Paket ----
  const openAddPaket = () => {
    setPaketForm({ ...emptyPaket });
    setPaketDialogOpen(true);
  };
  const openEditPaket = (row) => {
    setPaketForm({ Id: row.Id, PaketId: row.PaketId, Aciklama: row.Aciklama, Aktif: row.Aktif });
    setPaketDialogOpen(true);
  };

  const handleSavePaket = () => {
    if (!paketForm.Aciklama.trim()) return notify('error', 'Paket açıklaması boş olamaz.');
    setLoading(true);
    axios
      .post('/SetEkGarantiPaket', {
        Id: paketForm.Id,
        PaketId: paketForm.PaketId,
        Aciklama: paketForm.Aciklama.trim(),
        Aktif: paketForm.Aktif
      })
      .then((res) => {
        if (res.data && res.data.ErrorCode === '0') {
          notify('success', res.data.ErrorDescription || 'Kaydedildi.');
          setPaketDialogOpen(false);
          fetchAll();
        } else {
          notify('error', (res.data && res.data.ErrorDescription) || 'İşlem başarısız.');
        }
      })
      .catch(() => notify('error', 'Kayıt sırasında hata oluştu.'))
      .finally(() => setLoading(false));
  };

  const handleDelete = (url, baslik) => {
    askConfirm(baslik, 'Bu kaydı pasif hale getirmek istediğinize emin misiniz?', () => {
      setLoading(true);
      axios
        .get(url)
        .then((res) => {
          if (res.data && res.data.ErrorCode === '0') {
            notify('success', res.data.ErrorDescription || 'Pasif hale getirildi.');
            fetchAll();
          } else {
            notify('error', (res.data && res.data.ErrorDescription) || 'İşlem başarısız.');
          }
        })
        .catch(() => notify('error', 'İşlem sırasında hata oluştu.'))
        .finally(() => setLoading(false));
    });
  };

  // ---- Kampanya koşulları ----
  const loadKampanya = (paketId) => {
    if (!paketId) {
      setKampanyaItems([]);
      return;
    }
    setLoading(true);
    axios
      .get(`/GetKampanyaKosullar/${paketId}`)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setKampanyaItems(list.map((x) => ({ MarkdownTipId: x.MarkdownTipId, Metin: x.Metin })));
      })
      .catch(() => notify('error', 'Koşullar yüklenemedi.'))
      .finally(() => setLoading(false));
  };

  const onKampanyaPaketChange = (val) => {
    setKampanyaPaketId(val);
    loadKampanya(val);
  };

  const addKampanyaItem = (tip) => setKampanyaItems((p) => [...p, { MarkdownTipId: tip, Metin: '' }]);
  const updateKampanyaItem = (idx, metin) =>
    setKampanyaItems((p) => p.map((it, i) => (i === idx ? { ...it, Metin: metin } : it)));
  const removeKampanyaItem = (idx) => setKampanyaItems((p) => p.filter((_, i) => i !== idx));
  const moveKampanyaItem = (idx, dir) =>
    setKampanyaItems((p) => {
      const ni = idx + dir;
      if (ni < 0 || ni >= p.length) return p;
      const arr = [...p];
      const tmp = arr[idx];
      arr[idx] = arr[ni];
      arr[ni] = tmp;
      return arr;
    });

  const saveKampanya = () => {
    if (!kampanyaPaketId) return notify('error', 'Önce paket seçin.');
    const payload = {
      PaketId: Number(kampanyaPaketId),
      Items: kampanyaItems
        .filter((it) => it.Metin && it.Metin.trim())
        .map((it, idx) => ({ MarkdownTipId: it.MarkdownTipId, Metin: it.Metin.trim(), Sira: idx }))
    };
    setLoading(true);
    axios
      .post('/SetKampanyaKosullar', payload)
      .then((res) => {
        if (res.data && res.data.ErrorCode === '0') notify('success', res.data.ErrorDescription || 'Kaydedildi.');
        else notify('error', (res.data && res.data.ErrorDescription) || 'İşlem başarısız.');
      })
      .catch(() => notify('error', 'Kayıt sırasında hata oluştu.'))
      .finally(() => setLoading(false));
  };

  // Bir paketin koşullarını salt-okunur göster
  const openKosulView = (paket) => {
    setLoading(true);
    axios
      .get(`/GetKampanyaKosullar/${paket.PaketId}`)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setKosulView({ open: true, paketAdi: paket.Aciklama, items: list });
      })
      .catch(() => notify('error', 'Koşullar yüklenemedi.'))
      .finally(() => setLoading(false));
  };

  // Önizleme render'ı (hem düzenleyici hem görüntüleme dialog'unda kullanılır)
  const renderKosulPreview = (items, emptyText) => {
    const dolu = (items || []).filter((it) => it.Metin && it.Metin.trim());
    if (dolu.length === 0) return <Typography variant="body2" color="textSecondary">{emptyText}</Typography>;
    return (items || []).map((it, idx) => {
      if (!it.Metin || !it.Metin.trim()) return null;
      if (it.MarkdownTipId === 1)
        return (
          <Typography key={idx} variant="subtitle1" style={{ fontWeight: 600, marginTop: 10 }}>
            {it.Metin}
          </Typography>
        );
      if (it.MarkdownTipId === 3)
        return (
          <li key={idx} style={{ marginLeft: 18 }}>
            {it.Metin}
          </li>
        );
      return (
        <Typography key={idx} variant="body2" style={{ marginTop: 4 }}>
          {it.Metin}
        </Typography>
      );
    });
  };

  // Filtrelenmiş fiyat listesi
  const filtreliDetaylar = detaylar
    .filter((d) => (showPassive ? true : d.Aktif))
    .filter((d) => (filterPaketId ? d.PaketId === Number(filterPaketId) : true))
    .filter((d) => (filterUrunGrup ? d.UrunAnaGrupKodu === filterUrunGrup.Kod : true));

  const gorunenPaketler = paketler.filter((p) => (showPassive ? true : p.Aktif));

  return (
    <Page className={classes.root} title="Paket Yönetimi">
      <Backdrop open={loading} style={{ zIndex: 2000, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={snackOpen}
        autoHideDuration={4000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <AlertScreen variant={snackType} message={snackMessage} onClose={() => setSnackOpen(false)} />
      </Snackbar>

      <Card>
        <CardHeader
          avatar={<CardMembershipIcon color="primary" />}
          title="Paket Yönetimi"
          subheader="Ek garanti paket ve ürün ana grubu bazlı fiyat yönetimi"
          action={
            <FormControlLabel
              control={<Switch checked={showPassive} onChange={(e) => setShowPassive(e.target.checked)} color="primary" />}
              label="Pasifleri göster"
            />
          }
        />
        <Divider />
        <Tabs value={tab} onChange={(e, v) => setTab(v)} indicatorColor="primary" textColor="primary">
          <Tab label="Fiyat Yönetimi" />
          <Tab label="Paketler" />
          <Tab label="Kampanya Koşulları" />
        </Tabs>
        <Divider />

        <CardContent>
          {tab === 0 && (
            <>
              <div className={classes.toolbar}>
                <FormControl variant="outlined" size="small" className={classes.filterCtrl}>
                  <InputLabel>Paket (filtre)</InputLabel>
                  <Select label="Paket (filtre)" value={filterPaketId} onChange={(e) => setFilterPaketId(e.target.value)}>
                    <MenuItem value="">Tümü</MenuItem>
                    {paketler.map((p) => (
                      <MenuItem key={p.PaketId} value={p.PaketId}>
                        {p.Aciklama}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Autocomplete
                  size="small"
                  className={classes.filterCtrl}
                  options={urunGruplar}
                  value={filterUrunGrup}
                  getOptionLabel={(o) => (o ? `${o.Aciklama} (${o.Kod})` : '')}
                  getOptionSelected={(o, v) => o.Kod === v.Kod}
                  onChange={(e, val) => setFilterUrunGrup(val)}
                  renderInput={(params) => <TextField {...params} variant="outlined" label="Ürün Ana Grubu (filtre)" />}
                />

                <div className={classes.spacer} />
                <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={openAddDetay}>
                  Yeni Fiyat
                </Button>
              </div>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Ürün Ana Grubu</TableCell>
                    <TableCell>Paket</TableCell>
                    <TableCell align="right">Bakım Ek Garanti Adeti</TableCell>
                    <TableCell align="right">Fiyat (Aylık)</TableCell>
                    <TableCell>Başlangıç</TableCell>
                    <TableCell>Bitiş</TableCell>
                    <TableCell>Durum</TableCell>
                    <TableCell align="right">İşlem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtreliDetaylar.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Typography variant="body2" color="textSecondary">Kayıt bulunamadı.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                  {filtreliDetaylar.map((d) => (
                    <TableRow key={d.Id} className={d.Aktif ? '' : classes.passive}>
                      <TableCell>{d.UrunAnaGrupAdi || d.UrunAnaGrupKodu}</TableCell>
                      <TableCell>{d.PaketAdi || paketAdi(d.PaketId)}</TableCell>
                      <TableCell align="right">{d.BakimEkGarantiAdeti}</TableCell>
                      <TableCell align="right">{Number(d.Fiyat).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</TableCell>
                      <TableCell>{formatTr(d.FiyatBaslangic)}</TableCell>
                      <TableCell>{formatTr(d.FiyatBitis)}</TableCell>
                      <TableCell>
                        <Chip size="small" label={d.Aktif ? 'Aktif' : 'Pasif'} color={d.Aktif ? 'secondary' : 'default'} />
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Geçmiş">
                          <IconButton size="small" onClick={() => openLogView(d)}>
                            <HistoryIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Düzenle">
                          <IconButton size="small" onClick={() => openEditDetay(d)}>
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {d.Aktif && (
                          <Tooltip title="Pasifleştir">
                            <IconButton size="small" onClick={() => handleDelete(`/DeleteEkGarantiPaketDetay/${d.Id}`, 'Fiyatı Pasifleştir')}>
                              <DeleteIcon fontSize="small" color="error" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}

          {tab === 1 && (
            <>
              <div className={classes.toolbar}>
                <div className={classes.spacer} />
                <Button variant="contained" color="secondary" startIcon={<AddIcon />} onClick={openAddPaket}>
                  Yeni Paket
                </Button>
              </div>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Paket No</TableCell>
                    <TableCell>Açıklama</TableCell>
                    <TableCell>Durum</TableCell>
                    <TableCell align="right">İşlem</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {gorunenPaketler.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Typography variant="body2" color="textSecondary">Kayıt bulunamadı.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                  {gorunenPaketler.map((p) => (
                    <TableRow key={p.Id} className={p.Aktif ? '' : classes.passive}>
                      <TableCell>{p.PaketId}</TableCell>
                      <TableCell>{p.Aciklama}</TableCell>
                      <TableCell>
                        <Chip size="small" label={p.Aktif ? 'Aktif' : 'Pasif'} color={p.Aktif ? 'secondary' : 'default'} />
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Kampanya Koşulları">
                          <IconButton size="small" onClick={() => openKosulView(p)}>
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Düzenle">
                          <IconButton size="small" onClick={() => openEditPaket(p)}>
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {p.Aktif && (
                          <Tooltip title="Pasifleştir">
                            <IconButton size="small" onClick={() => handleDelete(`/DeleteEkGarantiPaket/${p.Id}`, 'Paketi Pasifleştir')}>
                              <DeleteIcon fontSize="small" color="error" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          )}

          {tab === 2 && (
            <>
              <div className={classes.toolbar}>
                <FormControl variant="outlined" size="small" className={classes.filterCtrl}>
                  <InputLabel>Paket</InputLabel>
                  <Select label="Paket" value={kampanyaPaketId} onChange={(e) => onKampanyaPaketChange(e.target.value)}>
                    {paketler.filter((p) => p.Aktif).map((p) => (
                      <MenuItem key={p.PaketId} value={p.PaketId}>
                        {p.Aciklama}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <div className={classes.spacer} />
                <Button variant="contained" color="secondary" onClick={saveKampanya} disabled={!kampanyaPaketId}>
                  Kaydet
                </Button>
              </div>

              {!kampanyaPaketId ? (
                <Typography variant="body2" color="textSecondary">
                  Düzenlemek için bir paket seçin.
                </Typography>
              ) : (
                <Grid container spacing={2}>
                  {/* Düzenleyici */}
                  <Grid item xs={12} md={7}>
                    <div style={{ marginBottom: 8 }}>
                      <Button size="small" startIcon={<AddIcon />} onClick={() => addKampanyaItem(1)}>
                        Başlık
                      </Button>
                      <Button size="small" startIcon={<AddIcon />} onClick={() => addKampanyaItem(2)}>
                        İçerik
                      </Button>
                      <Button size="small" startIcon={<AddIcon />} onClick={() => addKampanyaItem(3)}>
                        Madde
                      </Button>
                    </div>

                    {kampanyaItems.length === 0 && (
                      <Typography variant="body2" color="textSecondary">
                        Henüz satır yok. Başlık / İçerik / Madde ekleyin.
                      </Typography>
                    )}

                    {kampanyaItems.map((it, idx) => (
                      <div key={idx} className={classes.kampanyaRow}>
                        <Chip
                          size="small"
                          label={tipAdi(it.MarkdownTipId)}
                          className={classes.tipChip}
                          color={it.MarkdownTipId === 1 ? 'secondary' : 'default'}
                        />
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          multiline
                          placeholder={`${tipAdi(it.MarkdownTipId)} metni`}
                          value={it.Metin}
                          onChange={(e) => updateKampanyaItem(idx, e.target.value)}
                        />
                        <IconButton size="small" onClick={() => moveKampanyaItem(idx, -1)} disabled={idx === 0}>
                          <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => moveKampanyaItem(idx, 1)}
                          disabled={idx === kampanyaItems.length - 1}
                        >
                          <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton size="small" onClick={() => removeKampanyaItem(idx)}>
                          <DeleteIcon fontSize="small" color="error" />
                        </IconButton>
                      </div>
                    ))}
                  </Grid>

                  {/* Önizleme */}
                  <Grid item xs={12} md={5}>
                    <Typography variant="subtitle2" gutterBottom>
                      Önizleme
                    </Typography>
                    <div className={classes.preview}>
                      {renderKosulPreview(kampanyaItems, 'Önizleme burada görünecek.')}
                    </div>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </CardContent>
      </Card>

      {/* Fiyat (detay) dialog */}
      <Dialog open={detayDialogOpen} onClose={() => setDetayDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{detayForm.Id > 0 ? 'Fiyat Düzenle' : 'Yeni Fiyat'}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Paket</InputLabel>
                <Select label="Paket" value={detayForm.PaketId} onChange={(e) => setDetayField('PaketId', e.target.value)}>
                  {paketler.filter((p) => p.Aktif).map((p) => (
                    <MenuItem key={p.PaketId} value={p.PaketId}>
                      {p.Aciklama}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                size="small"
                options={urunGruplar}
                value={detayForm.UrunAnaGrup}
                getOptionLabel={(o) => (o ? `${o.Aciklama} (${o.Kod})` : '')}
                getOptionSelected={(o, v) => o.Kod === v.Kod}
                onChange={(e, val) => setDetayField('UrunAnaGrup', val)}
                renderInput={(params) => <TextField {...params} variant="outlined" label="Ürün Ana Grubu" />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth variant="outlined" size="small" type="number"
                label="Bakım Ek Garanti Adeti"
                value={detayForm.BakimEkGarantiAdeti}
                onChange={(e) => setDetayField('BakimEkGarantiAdeti', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth variant="outlined" size="small" type="number"
                label="Fiyat (Aylık ₺)"
                value={detayForm.Fiyat}
                onChange={(e) => setDetayField('Fiyat', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth variant="outlined" size="small" type="date"
                label="Geçerlilik Başlangıç" InputLabelProps={{ shrink: true }}
                value={detayForm.FiyatBaslangic}
                onChange={(e) => setDetayField('FiyatBaslangic', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth variant="outlined" size="small" type="date"
                label="Geçerlilik Bitiş" InputLabelProps={{ shrink: true }}
                value={detayForm.FiyatBitis}
                onChange={(e) => setDetayField('FiyatBitis', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch checked={detayForm.Aktif} color="primary" onChange={(e) => setDetayField('Aktif', e.target.checked)} />}
                label="Aktif"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetayDialogOpen(false)}>İptal</Button>
          <Button variant="contained" color="secondary" onClick={handleSaveDetay}>Kaydet</Button>
        </DialogActions>
      </Dialog>

      {/* Paket dialog */}
      <Dialog open={paketDialogOpen} onClose={() => setPaketDialogOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{paketForm.Id > 0 ? 'Paket Düzenle' : 'Yeni Paket'}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth variant="outlined" size="small"
                label="Paket Açıklaması" inputProps={{ maxLength: 200 }}
                value={paketForm.Aciklama}
                onChange={(e) => setPaketForm((p) => ({ ...p, Aciklama: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch checked={paketForm.Aktif} color="primary" onChange={(e) => setPaketForm((p) => ({ ...p, Aktif: e.target.checked }))} />}
                label="Aktif"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaketDialogOpen(false)}>İptal</Button>
          <Button variant="contained" color="secondary" onClick={handleSavePaket}>Kaydet</Button>
        </DialogActions>
      </Dialog>

      {/* Kampanya koşulları görüntüleme (salt-okunur) */}
      <Dialog
        open={kosulView.open}
        onClose={() => setKosulView((s) => ({ ...s, open: false }))}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{`Kampanya Koşulları — ${kosulView.paketAdi}`}</DialogTitle>
        <DialogContent dividers>
          {renderKosulPreview(kosulView.items, 'Bu pakete ait kampanya koşulu bulunmuyor.')}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setKosulView((s) => ({ ...s, open: false }))}>Kapat</Button>
        </DialogActions>
      </Dialog>

      {/* Fiyat değişiklik geçmişi */}
      <Dialog open={logView.open} onClose={() => setLogView((s) => ({ ...s, open: false }))} fullWidth maxWidth="md">
        <DialogTitle>{`Fiyat Geçmişi — ${logView.baslik}`}</DialogTitle>
        <DialogContent dividers>
          {logView.items.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Bu kayıt için geçmiş bulunmuyor.
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>İşlem</TableCell>
                  <TableCell>Fiyat (Aylık)</TableCell>
                  <TableCell>Dönem</TableCell>
                  <TableCell>Durum</TableCell>
                  <TableCell>Kullanıcı</TableCell>
                  <TableCell>Tarih</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logView.items.map((l) => (
                  <TableRow key={l.Id}>
                    <TableCell>
                      <Chip
                        size="small"
                        label={l.Islem}
                        color={l.Islem === 'PASIF' ? 'default' : 'secondary'}
                      />
                    </TableCell>
                    <TableCell>{`${fmtMoney(l.EskiFiyat)} → ${fmtMoney(l.YeniFiyat)}`}</TableCell>
                    <TableCell>
                      {`${formatTr(l.EskiBaslangic)}–${formatTr(l.EskiBitis)} → ${formatTr(l.YeniBaslangic)}–${formatTr(l.YeniBitis)}`}
                    </TableCell>
                    <TableCell>{`${fmtAktif(l.EskiAktif)} → ${fmtAktif(l.YeniAktif)}`}</TableCell>
                    <TableCell>{l.IslemYapan || '-'}</TableCell>
                    <TableCell>{formatTrDateTime(l.IslemTarihi)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogView((s) => ({ ...s, open: false }))}>Kapat</Button>
        </DialogActions>
      </Dialog>

      {/* Onay dialog */}
      <Dialog open={confirmState.open} onClose={closeConfirm} maxWidth="xs" fullWidth>
        <DialogTitle>{confirmState.title}</DialogTitle>
        <DialogContent>
          <Typography variant="body2">{confirmState.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirm}>Hayır</Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              const fn = confirmState.onConfirm;
              closeConfirm();
              if (fn) fn();
            }}
          >
            Evet
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default PaketYonetimi;
